module.exports = [
  0, 126, 125, 136, 123, 156, 135, 246, 346, 456, 245, 234, 345
]